var ezdia;
(function (ezdia) {
    function container(id) {
        return "<div\n      class=\"show-history-wrapper-padding alert alert-desk-item-status show-history-wrapper collapse in\"\n      id=\"" + id + "\">\n    </div>";
    }
    function emptyContent(msg) {
        if (msg === void 0) { msg = 'There are no previous versions to display.'; }
        return "<span class=\"text-muted\">" + msg + "</span>";
    }
    function errorContent(msg) {
        return "<span class=\"label label-danger\">" + msg + "</span>";
    }
    function listItemsContent(historyListArray) {
        var e_1, _a;
        var length = historyListArray.length;
        var htmlContentArray = [];
        var count = 0;
        try {
            for (var historyListArray_1 = __values(historyListArray), historyListArray_1_1 = historyListArray_1.next(); !historyListArray_1_1.done; historyListArray_1_1 = historyListArray_1.next()) {
                var listObject = historyListArray_1_1.value;
                var id = listObject.id, taskId = listObject.taskId, lastModifiedByRole = listObject.lastModifiedByRole, createdOn = listObject.createdOn;
                var cls = '';
                var statusType = lastModifiedByRole + " version <span class=\"text-muted small\">Created On</span> " + createdOn;
                if (count === 0) {
                    cls = 'current';
                    statusType = "Current " + statusType;
                }
                else if (count === length - 1) {
                    statusType = 'Original version';
                    cls = 'last-child';
                }
                htmlContentArray.push("<a class=\"list-group-item " + cls + "\"\n          data-item-id=\"" + (id || '') + "\"\n          data-item-taskId=\"" + (taskId || '') + "\"\n          href=\"javascript:;\">\n          " + statusType + "\n        </a>\n        <div class=\"histroy-compare-wrapper\" data-container-type=\"history compare\"></div>");
                count += 1;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (historyListArray_1_1 && !historyListArray_1_1.done && (_a = historyListArray_1.return)) _a.call(historyListArray_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return "<div class=\"list-group\">" + htmlContentArray.join('') + "</div>";
    }
    function itemContent(_a) {
        var createdOn = _a.createdOn, lastModifiedByRole = _a.lastModifiedByRole, content = _a.contentOld, jsContentID = _a.jsContentID;
        return "<div class=\"panel panel-default clearfix\">\n      <div class=\"panel-body show-histroy-diff\">\n        <div class=\"text-right\">\n        " + (content
            ? "<button type=\"button\" data-btn-type=\"compare\" class=\"btn btn-default btn-sm\">Compare to current copy</button>"
            : '') + "\n        <button type=\"button\" data-btn-type=\"revert\" class=\"btn btn-default btn-sm\" {{#if hideBtn}}disabled{{/if}}>Revert to this copy</button>\n        <button type=\"button\" data-btn-type=\"close\" class=\"btn btn-link btn-sm\">Close</button>\n        </div>\n        <hr>\n        <div id=\"" + jsContentID + "\">" + content + "</div>\n        <hr>\n        <div class=\"text-right text-muted \">\n          <span class=\"small\">Modified By:</span> " + lastModifiedByRole + "\n          <span class=\"small\">Created On:</span> " + createdOn + "\n        </div>\n      </div>\n    </div>";
    }
    var templates;
    (function (templates) {
        templates.history = {
            container: container,
            emptyContent: emptyContent,
            errorContent: errorContent,
            listItemsContent: listItemsContent,
            itemContent: itemContent
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
